/*global tinymce, jQuery */

;(function (tinymce, $) {
  'use strict';

  var A51Callout = function (ed) {
    this.editor = ed;

    this.editor.addCommand("a51ToggleCallout", (className) => {
      this.toggleWrap(className);
    });

    this.editor.on('keydown', (e) => {
      if (e.key === 'Backspace') {
        const node = this.editor.selection.getNode();
        const aside = node.closest('aside');

        if (aside) {
          const div = aside.querySelector('div');
          const isEmpty = !div || div.innerText.trim() === '';

          if (isEmpty) {
            e.preventDefault();
            this.editor.dom.remove(aside);
            this.editor.selection.collapse();
          }
        }
      }

      if (e.key === 'Enter') {
        const rng = this.editor.selection.getRng();
        let node = rng.startContainer;

        while (node && node.nodeType === 3) {
          node = node.parentNode;
        }

        const aside = this.editor.dom.getParent(node, 'aside');

        if (!aside) return;

        if (this.editor.dom.isEmpty(aside)) {
          e.preventDefault();

          const next = aside.nextSibling;
          this.editor.dom.remove(aside);

          if (next) {
            this.editor.selection.setCursorLocation(next, 0);
          } else {
            this.editor.execCommand('mceInsertParagraph');
          }
          return;
        }

        const li = this.editor.dom.getParent(node, 'li');
        if (li && this.editor.dom.isEmpty(li) && this.isLastChildInAside(li, aside)) {
          e.preventDefault();

          const newP = this.editor.dom.create('p', {}, '<br data-mce-bogus="1">');

          this.editor.dom.insertAfter(newP, li.parentNode);
          this.editor.dom.remove(li);

          this.editor.selection.setCursorLocation(newP, 0);
          return;
        }

        if (this.editor.dom.isEmpty(node) && this.isLastChildInAside(node, aside)) {
          e.preventDefault();

          this.editor.dom.remove(node);

          const newP = this.editor.dom.create('p', {}, '<br data-mce-bogus="1">');
          this.editor.dom.insertAfter(newP, aside);

          this.editor.selection.setCursorLocation(newP, 0);
        }
      }
    });
  };

  A51Callout.prototype = {
    constructor: A51Callout,

    isLastChildInAside: function (node, aside) {
      let block = node;
      while (block && block !== aside && !this.editor.dom.isBlock(block)) {
        block = block.parentNode;
      }
      if (!block || block === aside) return false;

      let next = block.nextSibling;
      while (next) {
        if (next.nodeType === 1) { // element
          if (!this.editor.dom.isEmpty(next)) {
            return false;
          }
        } else if (next.nodeType === 3) { // text
          if (next.nodeValue.trim() !== '') {
            return false;
          }
        }
        next = next.nextSibling;
      }

      let parent = block.parentNode;
      while (parent && parent !== aside) {
        let after = parent.nextSibling;
        while (after) {
          if (after.nodeType === 1 && !this.editor.dom.isEmpty(after)) return false;
          if (after.nodeType === 3 && after.nodeValue.trim() !== '') return false;
          after = after.nextSibling;
        }
        parent = parent.parentNode;
      }

      return true;
    },

    invalidSelection: function () {
      const rng = this.editor.selection.getRng();
      const fragment = rng.cloneContents();

      const containAside =
        fragment.querySelector &&
        fragment.querySelector('aside.callout-wrapper') !== null;

      const startAside = this.editor.dom.getParent(this.editor.selection.getStart(), 'aside.callout-wrapper');
      const endAside = this.editor.dom.getParent(this.editor.selection.getEnd(), 'aside.callout-wrapper');

      return (endAside !== startAside) || (!startAside && !endAside && containAside);
    },

    toggleWrap: function (className) {
      if (this.invalidSelection()) {
        return;
      }
      const currentNode = this.editor.selection.getNode();
      const selectedText = this.editor.selection.getContent({ format: 'html' });
      const closestAside = $(currentNode).closest('aside')[0];

      if (closestAside && closestAside.classList.contains(className)) {
        const content = closestAside.querySelector('div.callout-content');
        let lastMovedNode = null;

        if (content) {
          while (content.firstChild) {
            lastMovedNode = content.firstChild;
            closestAside.parentNode.insertBefore(lastMovedNode, closestAside);
          }
        }

        this.editor.dom.remove(closestAside);

        if (lastMovedNode) {
          this.editor.selection.select(lastMovedNode, false);
          this.editor.selection.collapse(false);
        }

        this.editor.focus();

      } else if (closestAside && !closestAside.classList.contains(className)) {
        closestAside.className = `callout-wrapper ${className}`;
      } else {
        let content = selectedText;
        const hasBlock = /<(p|div|ul|ol|blockquote|h[1-6])[\s>]/i.test(content);
        if (!hasBlock) {
          content = this.editor.dom.createHTML('p', null, content || '<br data-mce-bogus="1">');
        }
        const asideContent = this.editor.dom.createHTML(
          'aside',
          { class: `callout-wrapper ${className}` },
          this.editor.dom.createHTML(
            'div',
            { class: 'callout-content' },
            content
          )
        );
        this.editor.insertContent(asideContent);
      }
    }
  };

  tinymce.PluginManager.add('a51callout', function (ed, url) {
    new A51Callout(ed);
  });
})(tinymce, jQuery);
